import { render, staticRenderFns } from "./NoFeed.vue?vue&type=template&id=2c316404&scoped=true&"
import script from "./NoFeed.vue?vue&type=script&lang=js&"
export * from "./NoFeed.vue?vue&type=script&lang=js&"
import style0 from "./NoFeed.vue?vue&type=style&index=0&id=2c316404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c316404",
  null
  
)

export default component.exports